import { usePrefectureDashboardData } from '@/hooks/usePrefectureDashboardData'

const RecentPerformance = () => {
  const { data, isLoading, error } = usePrefectureDashboardData()

  if (isLoading) {
    return <div className="bg-white p-6 rounded-lg shadow animate-pulse">読み込み中...</div>
  }

  if (error || !data) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <p className="text-red-800">データの読み込みに失敗しました</p>
      </div>
    )
  }

  const { recentPerformance } = data

  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <h2 className="text-xl font-semibold mb-4">最近の成績</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">年度</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">大会名</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">最高成績</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">総試合数</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">勝率</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {recentPerformance.map((item, index) => (
              <tr key={index}>
                <td className="px-4 py-3 text-sm text-gray-900">{item.year}</td>
                <td className="px-4 py-3 text-sm text-gray-900">{item.tournamentName}</td>
                <td className="px-4 py-3 text-sm text-gray-900">{item.bestResult}</td>
                <td className="px-4 py-3 text-sm text-gray-900">{item.totalMatches}</td>
                <td className="px-4 py-3 text-sm text-gray-900">{item.winRate.toFixed(1)}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default RecentPerformance

